export default "__VITE_ASSET__BlylAXte__"